// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_button__rzDIN {
  margin-bottom: 1rem; }
`, "",{"version":3,"sources":["webpack://./src/modules/auth/submodules/invitations/components/CreateInvitationLinkButton/styles.module.scss"],"names":[],"mappings":"AAAA;EACI,mBAAmB,EAAA","sourcesContent":[".button {\n    margin-bottom: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `styles_button__rzDIN`
};
export default ___CSS_LOADER_EXPORT___;
